<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<div class="kt-login__title">
			<h3>{{ 'AUTH.GENERAL.ENTER_TO_APP' | translate }}</h3>
		</div>

		<kt-auth-notice></kt-auth-notice>

		<!--begin::Form-->
		<form class="kt-form" autocomplete="off">
			<!--begin::Action-->
			<div class="kt-login__actions" style="justify-content: center !important;">
				<button (click)="submit()" id="kt_login_signin_submit" class="btn btn-default btn-elevate kt-login__btn-primary">
					{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | translate }}
				</button>
			</div>
			<!--end::Action-->
		</form>
		<!--end::Form-->

		<!--begin::Divider-->
		<div class="kt-login__divider">
			<div class="kt-divider">
				<span></span>
				<span>{{ 'AUTH.GENERAL.LANGUAJE' | translate }}</span>
				<span></span>
			</div>
		</div>
		<!--end::Divider-->

		<!--begin::Options-->
		<div style="width: 26px;justify-content: center !important;">
		<kt-language-selector></kt-language-selector>
		</div>
		<!--end::Options-->
		<div style="position: fixed; bottom: 5px; right: 10px;">
			{{'COMMON.VERSION' | translate}} {{version}}
		</div>
	</div>
	<!--end::Signin-->
</div>
<!--end::Body-->
